import styled from 'styled-components';
import { DecorationImage, MEDIA_QUERY, Stack, alpha, getSpacingToken, getToken, Container } from '@optimus-web/core';

export const Image = styled(DecorationImage)`
    display: none;
    min-height: 100vh;
    min-height: 100svh; /* stylelint-disable-line unit-no-unknown */
    ${MEDIA_QUERY.desktopUp} {
        display: block;
    }
`;

export const ContentWrapper = styled(Container)`
    min-height: 100vh;
    min-height: 100svh; /* stylelint-disable-line unit-no-unknown */
`;

export const ImageContentWrapper = styled(Stack)`
    height: 100vh;
    min-height: 100svh; /* stylelint-disable-line unit-no-unknown */
    padding: ${getSpacingToken('400')}px;
    background: ${({ theme }) => alpha(getToken('paletteBrandNight900')({ theme }), getToken('opacity200')({ theme }))};
    justify-content: space-between;
`;
